import React, { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { useMsal } from "@azure/msal-react";
import { useAuth } from "../../context/AuthContext";
import { loginRequest, relayState } from "../../authConfig";
import { SESSION_REFRESH_DIALOG_Z_INDEX } from "../../feedback/overlayZIndex";
import {
  getSessionRefreshNotice,
  subscribeSessionRefreshNotice,
} from "../../api/sessionRefresh";

export default function SessionAlerts() {
  const { sessionToast, setSessionToast } = useAuth();
  const { instance } = useMsal();
  const [refreshNotice, setRefreshNotice] = useState(getSessionRefreshNotice);

  useEffect(() => subscribeSessionRefreshNotice(setRefreshNotice), []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSessionToast((prev) => ({ ...prev, open: false }));
  };

  const signInAgain = async () => {
    sessionStorage.setItem(
      "redirectAfterLogin",
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    );
    try {
      await instance.loginRedirect({ ...loginRequest, state: relayState() });
    } catch (e) {
      console.error("Failed to redirect to login:", e);
    }
  };

  return (
    <>
      <Snackbar
        open={sessionToast.open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={sessionToast.severity} variant="filled" onClose={handleClose} sx={{ width: "100%" }}>
          {sessionToast.message}
        </Alert>
      </Snackbar>
      <Dialog
        container={() => document.body}
        open={Boolean(refreshNotice)}
        disableEscapeKeyDown
        onClose={(_event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        }}
        slotProps={{ root: { sx: { zIndex: SESSION_REFRESH_DIALOG_Z_INDEX } } }}
        aria-labelledby="session-refresh-title"
      >
        <DialogTitle id="session-refresh-title">Sign in required</DialogTitle>
        <DialogContent>{refreshNotice?.detail}</DialogContent>
        <DialogActions>
          <Button variant="outlined" startIcon={<LoginIcon />} onClick={signInAgain}>
            Sign in again
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
